export const RoleType = {
  User: 1,
  Admin: 2,
  Manager: 3,
  AI: 4,
} as const;

export const RoleObject = {
  1: "User",
  2: "Admin",
  3: "Manager",
  4: "AI",
};

export const RoleGroupType = {
  Front: 1,
  Admin: 2,
  AI: 3,
} as const;

export const StatusActiveUser = {
  Banned: -999,
  Pending: 0,
  Active: 1,
} as const;


export type RoleTypeValue = typeof RoleType[keyof typeof RoleType];
export type RoleTypeGroupValue = typeof RoleGroupType[keyof typeof RoleGroupType];
export type StatusActiveUserValue = typeof StatusActiveUser[keyof typeof StatusActiveUser];